import { apiClient } from './client';

export interface ScrapeRunSummary {
  id: number;
  city_id: number | null;
  city_name: string | null;
  run_type: string;   // market_list | detail_monitor | single_detail | batch_detail
  trigger: string;    // scheduler | manual
  status: string;     // running | completed | completed_with_errors | failed | skipped_locked
  started_at: string;
  finished_at: string | null;
  checked: number;
  online: number;
  offline: number;
  failed: number;
  error: string | null;
  error_count: number;
}

export interface ScrapeLogEntry {
  id: number;
  listing_id: number | null;
  listing_title: string | null;
  level: string; // error | warning | info
  message: string;
  created_at: string;
}

export interface ScrapeRunDetail extends ScrapeRunSummary {
  entries: ScrapeLogEntry[];
}

/** Admin scrape log. system_admin only. */
export const scrapeRunsApi = {
  list: async (params?: { city_id?: number; status?: string; run_type?: string; limit?: number }): Promise<ScrapeRunSummary[]> => {
    const { data } = await apiClient.get('/admin/scrape-runs', { params });
    return data;
  },

  get: async (runId: number): Promise<ScrapeRunDetail> => {
    const { data } = await apiClient.get(`/admin/scrape-runs/${runId}`);
    return data;
  },
};
